import type { ClientRegisterEventHandlerFn } from './index'

import { registerAccountEventHandlers } from './account'
import { registerBasicEventHandlers } from './auth'
import { registerDialogEventHandlers } from './dialog'
import { registerEntityEventHandlers } from './entity'
import { registerMessageEventHandlers } from './message'
import { registerServerEventHandlers } from './server'
import { registerStorageEventHandlers } from './storage'
import { registerTakeoutEventHandlers } from './takeout'

export function registerAllEventHandlers(
  registerEventHandler: ClientRegisterEventHandlerFn,
) {
  registerServerEventHandlers(registerEventHandler)
  registerBasicEventHandlers(registerEventHandler)
  registerEntityEventHandlers(registerEventHandler)
  registerTakeoutEventHandlers(registerEventHandler)
  registerAccountEventHandlers(registerEventHandler)
  registerDialogEventHandlers(registerEventHandler)
  registerStorageEventHandlers(registerEventHandler)
  registerMessageEventHandlers(registerEventHandler)
}
